import React from "react"
import { ArrowLeftThin, ArrowRightThin } from "components/SVG"

import {
  container,
  paginationItems,
  paginationParagraph,
} from "./BlogPagination.css"
import { PageNumber } from "./PageNumber"
import { filterItemsToShow } from "components/Blog/utils/Blog.utils"

type Props = {
  currentPage: number
  totalItems: number
  itemsPerPage: number
  slug: string
  noHeroImage?: boolean
  locale: "en-GB" | "en-US"
}

export const BlogPagination: React.FC<Props> = ({
  currentPage,
  totalItems,
  itemsPerPage,
  slug,
  noHeroImage = false,
  locale,
}) => {
  const { itemsToShow, items } = filterItemsToShow(
    currentPage,
    noHeroImage === true ? totalItems : totalItems + 1, // Add 1 to total to account for hero on page 1
    itemsPerPage
  )
  const slugToUse = locale === "en-US" ? `/us${slug}` : slug
  return (
    <div className={container}>
      <div className={paginationItems}>
        {currentPage !== 1 && (
          <a
            href={
              currentPage === 2
                ? slugToUse
                : `${slugToUse}/page/${currentPage - 1}`
            }
            title="Previous Page"
            rel="prev"
          >
            <ArrowLeftThin />
          </a>
        )}
        <p className={paginationParagraph}>
          {itemsToShow.map((num) => {
            return (
              <PageNumber
                key={num}
                link={num === 1 ? slugToUse : `${slugToUse}/page/${num}`}
                num={num}
                current={num === currentPage}
                currentNum={currentPage}
              />
            )
          })}
        </p>
        {currentPage !== items.length && (
          <>
            {currentPage < items.length - 2 && (
              <p className={paginationParagraph}>
                ...
                <PageNumber
                  link={`${slugToUse}/page/${items.length}`}
                  num={items.length}
                />
              </p>
            )}
            <a
              href={`${slugToUse}/page/${currentPage + 1}`}
              title="Next Page"
              rel="next"
            >
              <ArrowRightThin />
            </a>
          </>
        )}
      </div>
    </div>
  )
}
